import { Http } from '../../common/api';
import { PricingApiConfiguration } from '../models/pricing-api-configuration';

let PRICING_API_API_CONFIG: PricingApiConfiguration = {
  baseUrl: '',
  isSFCCPricingOn: false,
  shopApiClientId: '',
  marketLocale: '',
};

export const pricingHttp = new Http();

export const getPricingApiConfig = (): PricingApiConfiguration => {
  return { ...PRICING_API_API_CONFIG };
};

export const initializePricingHttp = (config: PricingApiConfiguration): void => {
  PRICING_API_API_CONFIG = {
    ...PRICING_API_API_CONFIG,
    ...config,
  };

  pricingHttp.initializeHttp(config.baseUrl);
};

export const isPricingApiConfigured = (): boolean => {
  return pricingHttp.isReady();
};
